var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Companies", path: { name: "admin-companies" } }],
          name: _vm.loading ? "Edit Company" : _vm.company.name,
          "no-title": "",
        },
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "4", md: "5" } },
                [
                  _c(
                    "admin-panel",
                    {
                      attrs: { "second-body": "", "with-footer": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "second-body",
                            fn: function () {
                              return [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("Current Tier Level"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "h6",
                                  [
                                    _c("star-rating", {
                                      attrs: { rating: _vm.company.tier_level },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("Current Rating"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "h6",
                                  [
                                    _vm.company.rating_level !== null
                                      ? _c("star-rating", {
                                          attrs: {
                                            rating: _vm.company.rating_level,
                                          },
                                        })
                                      : _c("span", [_vm._v("New User")]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("Current Status"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "h6",
                                  [
                                    _c("admin-company-status-badge", {
                                      attrs: { company: _vm.company },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.approvedOn
                                  ? [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v("Approved")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h6",
                                        [
                                          _vm._v(
                                            "\n                on " +
                                              _vm._s(_vm.approvedOn) +
                                              "\n                "
                                          ),
                                          _vm.company.approved_by
                                            ? [
                                                _c("br"),
                                                _vm._v(
                                                  "by\n                  "
                                                ),
                                                _c(
                                                  "b-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name: "admin-user",
                                                        params: {
                                                          id: _vm.company.approved_by.id.toString(),
                                                        },
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.company
                                                            .approved_by.name
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  : _vm.rejectedOn
                                  ? [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v("Rejected")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h6",
                                        [
                                          _vm._v(
                                            "\n                on " +
                                              _vm._s(_vm.rejectedOn) +
                                              "\n                "
                                          ),
                                          _vm.company.rejected_by
                                            ? [
                                                _c("br"),
                                                _vm._v(
                                                  "by\n                  "
                                                ),
                                                _c(
                                                  "b-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name: "admin-user",
                                                        params: {
                                                          id: _vm.company.rejected_by.id.toString(),
                                                        },
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.company
                                                            .rejected_by.name
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _vm.company.status
                                  ? _c(
                                      "div",
                                      { staticClass: "text-center mt-n1" },
                                      [
                                        _vm.company.status.code === "active"
                                          ? _c(
                                              "no-permission-wrapper",
                                              {
                                                attrs: {
                                                  show: !_vm.canUpdateCompanies,
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-btn",
                                                  {
                                                    staticClass: "mt-1",
                                                    attrs: {
                                                      variant: "danger",
                                                      disabled:
                                                        !_vm.canUpdateCompanies,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.deactivateCompany.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  Suspend Company\n                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.company.status.code === "pending"
                                          ? [
                                              _c(
                                                "no-permission-wrapper",
                                                {
                                                  attrs: {
                                                    show: !_vm.canUpdateCompanies,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "b-btn",
                                                    {
                                                      staticClass: "mt-1",
                                                      attrs: {
                                                        variant: "success",
                                                        disabled:
                                                          !_vm.canUpdateCompanies,
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.activateCompany,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    Activate Company\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "no-permission-wrapper",
                                                {
                                                  attrs: {
                                                    show: !_vm.canUpdateCompanies,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "b-btn",
                                                    {
                                                      staticClass: "mt-1",
                                                      attrs: {
                                                        variant: "danger",
                                                        disabled:
                                                          !_vm.canUpdateCompanies,
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.rejectCompany,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    Reject Company\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm.company.status.code ===
                                            "suspended"
                                          ? _c(
                                              "no-permission-wrapper",
                                              {
                                                attrs: {
                                                  show: !_vm.canUpdateCompanies,
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-btn",
                                                  {
                                                    staticClass: "mt-1",
                                                    attrs: {
                                                      variant: "success",
                                                      disabled:
                                                        !_vm.canUpdateCompanies,
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.activateCompany,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  Activate Company\n                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2788132707
                      ),
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "mt-3 text-center" },
                        [
                          _vm.company.logo_url
                            ? _c("b-avatar", {
                                attrs: {
                                  variant: "primary",
                                  src: _vm.company.logo_url,
                                  size: "150",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("h4", { staticClass: "card-title mt-3" }, [
                            _vm._v(_vm._s(_vm.company.name)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "h6",
                            { staticClass: "card-subtitle" },
                            [
                              _vm._v(
                                "\n              Created On " +
                                  _vm._s(_vm.createdOn) +
                                  "\n              "
                              ),
                              _vm.company.created_by
                                ? [
                                    _c("br"),
                                    _vm._v("by\n                "),
                                    _c(
                                      "b-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "admin-user",
                                            params: {
                                              id: _vm.company.created_by.id.toString(),
                                            },
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.company.created_by.name
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isRejected
                ? _c(
                    "b-col",
                    { attrs: { lg: "8", md: "7" } },
                    [
                      _c(
                        "admin-panel",
                        { attrs: { "sub-title": "Edit Company Data" } },
                        [
                          _c(
                            "b-form",
                            {
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submitForm.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Company Name" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      state: _vm.fieldValid("name"),
                                      disabled: !_vm.canUpdateCompanies,
                                    },
                                    model: {
                                      value: _vm.formData.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "name",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "formData.name",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: { state: _vm.fieldValid("name") },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.formValidation.name) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "no-permission-wrapper",
                                { attrs: { show: !_vm.canUpdateCompanies } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        variant: "primary",
                                        disabled:
                                          _vm.formState.processing === "main" ||
                                          !_vm.canUpdateCompanies,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Update company Data\n                "
                                      ),
                                      _vm.formState.processing === "main"
                                        ? _c("b-spinner", {
                                            staticClass: "ml-1",
                                            attrs: { small: "" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "admin-panel",
                        { attrs: { "sub-title": "Support Rep" } },
                        [
                          _c(
                            "b-form",
                            {
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submitSupportRep.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Support Rep" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      state: _vm.fieldValid("support_rep"),
                                      disabled: !_vm.canUpdateCompanies,
                                    },
                                    model: {
                                      value: _vm.repFormData.support_rep,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.repFormData,
                                          "support_rep",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "repFormData.support_rep",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state: _vm.fieldValid("support_rep"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.formValidation.support_rep
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "no-permission-wrapper",
                                { attrs: { show: !_vm.canUpdateCompanies } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        variant: "primary",
                                        disabled:
                                          _vm.formState.processing ===
                                            "supportRep" ||
                                          !_vm.canUpdateCompanies,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Update Support Rep\n                "
                                      ),
                                      _vm.formState.processing === "supportRep"
                                        ? _c("b-spinner", {
                                            staticClass: "ml-1",
                                            attrs: { small: "" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "admin-panel",
                        { attrs: { "sub-title": "Sales Rep" } },
                        [
                          _c(
                            "b-form",
                            {
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submitSalesRep.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Sales Rep" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      state: _vm.fieldValid("sales_rep"),
                                      disabled: !_vm.canUpdateCompanies,
                                    },
                                    model: {
                                      value: _vm.repFormData.sales_rep,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.repFormData,
                                          "sales_rep",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "repFormData.sales_rep",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state: _vm.fieldValid("sales_rep"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.formValidation.sales_rep) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "no-permission-wrapper",
                                { attrs: { show: !_vm.canUpdateCompanies } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        variant: "primary",
                                        disabled:
                                          _vm.formState.processing ===
                                            "salesRep" ||
                                          !_vm.canUpdateCompanies,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Update Sales Rep\n                "
                                      ),
                                      _vm.formState.processing === "salesRep"
                                        ? _c("b-spinner", {
                                            staticClass: "ml-1",
                                            attrs: { small: "" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "admin-panel",
                        { attrs: { "sub-title": "Company Tier Level" } },
                        [
                          _c(
                            "b-form",
                            {
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submitTierLevel.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Tier Level" } },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      state: _vm.fieldValid("tier_level"),
                                      options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                                      disabled: !_vm.canUpdateCompanies,
                                    },
                                    model: {
                                      value: _vm.tierFormData.tier_level,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.tierFormData,
                                          "tier_level",
                                          $$v
                                        )
                                      },
                                      expression: "tierFormData.tier_level",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state: _vm.fieldValid("tier_level"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.formValidation.tier_level
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "no-permission-wrapper",
                                { attrs: { show: !_vm.canUpdateCompanies } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        variant: "primary",
                                        disabled:
                                          _vm.formState.processing === "tier" ||
                                          !_vm.canUpdateCompanies,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Update company Tier Level\n                "
                                      ),
                                      _vm.formState.processing === "tier"
                                        ? _c("b-spinner", {
                                            staticClass: "ml-1",
                                            attrs: { small: "" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "admin-panel",
                        { attrs: { "sub-title": "Company Facilities" } },
                        [
                          _c(
                            "b-overlay",
                            { attrs: { show: _vm.licenses.loading } },
                            [
                              _vm.canReadLicenses
                                ? _c("admin-licenses-table", {
                                    attrs: {
                                      licenses: _vm.licenses.rows,
                                      "with-actions": "",
                                    },
                                    on: {
                                      disapprove: _vm.disapproveLicense,
                                      approve: _vm.requestApproveLicense,
                                      resync: _vm.requestResyncLicense,
                                    },
                                  })
                                : _c(
                                    "div",
                                    { staticClass: "text-danger font-medium" },
                                    [
                                      _vm._v(
                                        "Sorry! You don't have permission to read licenses."
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "admin-panel",
                        { attrs: { "sub-title": "External Integrations" } },
                        [
                          _c(
                            "b-form",
                            {
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submitLeafLink.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "LeafLink API Key" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      state: _vm.fieldValid("leaflink_api_key"),
                                      disabled: !_vm.canUpdateCompanies,
                                    },
                                    model: {
                                      value: _vm.formData.leaflink_api_key,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "leaflink_api_key",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "formData.leaflink_api_key",
                                    },
                                  }),
                                  _vm._v(
                                    "\n              Leave empty if you don't want to update it\n              "
                                  ),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state:
                                          _vm.fieldValid("leaflink_api_key"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.formValidation.leaflink_api_key
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "no-permission-wrapper",
                                { attrs: { show: !_vm.canUpdateCompanies } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        variant: "primary",
                                        disabled:
                                          _vm.formState.processing ===
                                            "leaflink" ||
                                          !_vm.canUpdateCompanies,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Update Leaflink Key\n                "
                                      ),
                                      _vm.formState.processing === "leaflink"
                                        ? _c("b-spinner", {
                                            staticClass: "ml-1",
                                            attrs: { small: "" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "admin-panel",
                    {
                      attrs: { "sub-title": "Company Users" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header-right",
                            fn: function () {
                              return [
                                _c(
                                  "no-permission-wrapper",
                                  { attrs: { show: !_vm.canCreateUsers } },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "success",
                                          disabled: !_vm.canCreateUsers,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.openNewUserModal.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Add new Company User")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3145454317
                      ),
                    },
                    [
                      _c(
                        "b-overlay",
                        { attrs: { show: _vm.users.loading } },
                        [
                          _vm.canReadUsers
                            ? _c("admin-users-table", {
                                attrs: { users: _vm.users.rows },
                              })
                            : _c(
                                "div",
                                { staticClass: "text-danger font-medium" },
                                [
                                  _vm._v(
                                    "Sorry! You don't have permission to read users."
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "admin-panel",
                    {
                      attrs: { "sub-title": "Company Pricing Plans" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header-right",
                            fn: function () {
                              return [
                                _c(
                                  "no-permission-wrapper",
                                  {
                                    attrs: { show: !_vm.canAssignPricingPlans },
                                  },
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: {
                                          variant: "success",
                                          disabled: !_vm.canAssignPricingPlans,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.openNewPricingPlanModal.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                Assign new Pricing Plan\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2799658628
                      ),
                    },
                    [
                      _vm.canReadPricingPlans
                        ? [
                            _vm.company.pricing_plans.length
                              ? _c("admin-pricing-plans-table", {
                                  attrs: {
                                    plans: _vm.company.pricing_plans,
                                    "company-view": "",
                                  },
                                  on: { cancel: _vm.cancelPricingPlan },
                                })
                              : _c("h4", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    "No pricing plans connected to this company"
                                  ),
                                ]),
                          ]
                        : _c(
                            "div",
                            { staticClass: "text-danger font-medium" },
                            [
                              _vm._v(
                                "Sorry! You don't have permission to read pricing plans."
                              ),
                            ]
                          ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.licenseToApprove
        ? _c("admin-license-approve-modal", {
            attrs: { license: _vm.licenseToApprove, visible: "" },
            on: {
              approve: _vm.approveLicense,
              cancel: function ($event) {
                _vm.licenseToApprove = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.licenseToResync
        ? _c("admin-license-resync-modal", {
            attrs: { license: _vm.licenseToResync, visible: "" },
            on: {
              approve: _vm.resyncLicense,
              cancel: function ($event) {
                _vm.licenseToResync = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.company.id
        ? _c("admin-new-user-modal", {
            ref: "newUserModal",
            attrs: { "skip-admin-role": "", "company-id": _vm.company.id },
            on: { created: _vm.onNewUserAdded },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.company.id
        ? _c("admin-new-company-pricing-plan-modal", {
            ref: "newPricingPlanModal",
            attrs: {
              "current-plans": _vm.company.pricing_plans,
              "company-id": _vm.company.id,
            },
            on: { created: _vm.onNewPricingPlanAdded },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }